import { ChangeDetectionStrategy, Component, computed, inject, linkedSignal } from "@angular/core";

import { Dialog } from "primeng/dialog";
import { Button } from "primeng/button";
import { UiCoreErrorComponent } from "@rr/shared-ui-core";
import { ApiStore } from "@rr/shared-data-access-core";

@Component({
  selector: "rr-error-modal",
  imports: [Dialog, Button, UiCoreErrorComponent],
  templateUrl: "./error-modal.component.html",
  styleUrl: "./error-modal.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorModalComponent {
  // DI
  apiStore = inject(ApiStore);

  // Template variables
  showApiError = linkedSignal(() => this.apiStore.show());
  errorMessages = computed(() => (this.apiStore.errorMessage() ? this.apiStore.errorMessage()!.join(". ") : null));
}
